import { useMemo } from 'react'

import { Toaster } from '@/system/toaster'
import { RouterContext } from '@editor/contexts/Router'
import { GlobalModalProvider, LoadingPage, MaintenancePage } from '@infraloop/common'
import { useTranslation } from '@infraloop/i18n'
import { RouterProvider } from 'react-router'

import useServiceStatus from './hooks/useServiceStatus'
import { router } from './services/Router'

const App = () => {
  const { t } = useTranslation()

  // Service status check — blocks the app until resolved, before any route renders.
  const { serviceStatus, isLoading: isServiceStatusLoading } = useServiceStatus()

  // The editor body reads the router handle from this context (see EditorHost); provided
  // app-wide here, above the router, so the editor pages hosted in-app can reach it.
  const routerContextValue = useMemo(() => ({ router }), [])

  const renderContent = () => {
    if (isServiceStatusLoading || !serviceStatus) {
      return <LoadingPage text={t('ui.loading')} />
    }

    if (serviceStatus.isDown.enabled) {
      return <MaintenancePage isDown={serviceStatus.isDown} />
    }

    return (
      <RouterContext.Provider value={routerContextValue}>
        <RouterProvider router={router} />
      </RouterContext.Provider>
    )
  }

  return (
    <GlobalModalProvider
      textConfig={{
        defaultCancelText: t('ui.cancel'),
        defaultConfirmText: t('ui.confirm'),
        defaultTitle: t('ui.attention'),
        errorConfirmText: t('ui.accept'),
        errorTitle: t('ui.error'),
      }}
    >
      <>
        {renderContent()}
        <Toaster />
      </>
    </GlobalModalProvider>
  )
}

export default App
